<template>
  <div class="commissionRateCell fz-13 flex-row">
    <div class="white-space-nowrap">
      <div>
          <span class="mr-6">普通</span>
          <span>{{ row.commission_rate }}%</span>
      </div>
      <div>
          <span class="mr-6">团长</span>
          <span>{{ row.activity_commission_rate }}%</span>
      </div>
    </div>
    <div v-if="row.cos_type == 1 && row['activity_ad_cos_ratio'] != undefined" class="white-space-nowrap">
      <span class="mr-6"><span style="color: #999;margin: 0 4px;">|</span>投放期</span>
      <span>{{ row.activity_ad_cos_ratio }}%</span>
    </div>
  </div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
  mixins: [mixin]
}
</script>
<style lang="less" scoped>
.white-space-nowrap {
  white-space: nowrap;
}
</style>
